import processAsyncVariables from "../../variables/utils/process-async-variables";
import initAnimate from "../utils/init-animate";
import initClassObserver from "../utils/init-class-observer";
import initImmediate from "../utils/init-immediate";
import initTimeout from "../utils/init-timeout";

/**
 * Initialize triggers that should run after TorusKit initialization (on load)
 * @param {Set<TorusElement> | Array<TorusElement> | null} [targets]
 */
const afterInit = (targets = null) => {
  const elements = new Map();

  if (targets) {
    for (const target of targets) {
      if (target.Torus && target.dataset.tor) {
        elements.set(target, target.Torus.Main);
      }
    }
  }

  setTimeout(() => {
    /** Initialize "class" mutation observer */
    initClassObserver();

    /** Initialize "timeout" triggers */
    initTimeout(elements);

    /** Immediate triggers (class, change) */
    initImmediate(elements);

    /** Initialize "animate" triggers */
    initAnimate(elements);

    /** Re-init elements with reference to `$$` global variables  */
    processAsyncVariables();
  }, 0);
};

export default afterInit;
